/**
 * Central date formatting utilities.
 * All user-facing dates should go through here so we stay consistent
 * (French long-form, e.g. "lundi 10 juillet 2026").
 */

const FR = "fr-FR";

/**
 * Convert an ISO/date string or Date into a JS Date (or null when invalid).
 */
function _toDate(input) {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input) ? null : input;
  const d = new Date(input);
  return isNaN(d) ? null : d;
}

/**
 * "lundi 10 juillet 2026"
 */
export function formatDateLong(input) {
  const d = _toDate(input);
  if (!d) return "";
  return d.toLocaleDateString(FR, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/**
 * "lundi 10 juillet 2026 · 14:30"
 */
export function formatDateTimeLong(input) {
  const d = _toDate(input);
  if (!d) return "";
  return (
    d.toLocaleDateString(FR, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    }) +
    " · " +
    d.toLocaleTimeString(FR, { hour: "2-digit", minute: "2-digit" })
  );
}

/**
 * "10 juillet 2026" — compact French, no weekday.
 */
export function formatDateShort(input) {
  const d = _toDate(input);
  if (!d) return "";
  return d.toLocaleDateString(FR, { day: "numeric", month: "long", year: "numeric" });
}

/**
 * "14:30" — hour + minutes only, French.
 */
export function formatTime(input) {
  const d = _toDate(input);
  if (!d) return "";
  return d.toLocaleTimeString(FR, { hour: "2-digit", minute: "2-digit" });
}

/**
 * Capitalise the first character (French weekdays are lowercased by default).
 */
export function formatDateLongCapitalized(input) {
  const s = formatDateLong(input);
  return s ? s.charAt(0).toLocaleUpperCase(FR) + s.slice(1) : "";
}
